import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio219: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconAspectRatio219"><Path d="M0.75 6C0.335786 6 0 6.33579 0 6.75V17.25C0 17.6642 0.335786 18 0.75 18H23.25C23.6642 18 24 17.6642 24 17.25V6.75C24 6.33579 23.6642 6 23.25 6H0.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio219;
